import { logoutUserSuccess, apiError, reset_login_flag } from './reducer';

export const logoutUser = () => async (dispatch : any) => {
  try {
    sessionStorage.removeItem("authUser");
    sessionStorage.removeItem("tokenUser");
    sessionStorage.removeItem("applicationParameters");
    dispatch(logoutUserSuccess(true));
  } catch (error : any) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch : any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error : any ){
    dispatch(apiError(error));
  }
};
